import { useT } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useT();
  const values = t("about.values");

  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="blob blob-1" style={{ width: 520, height: 520, top: "0%", left: "-180px", opacity: 0.22 }} data-parallax="0.1" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative">
        <div className="grid grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="col-span-12 md:col-span-5">
            <div className="reveal flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-[#0F0524]/40" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-[#5C527A] font-semibold">
                {t("about.eyebrow")}
              </span>
            </div>
            <h2 className="reveal font-display text-5xl md:text-6xl font-extralight leading-[0.95] tracking-[-0.04em] text-[#0F0524]">
              {t("about.titleA")} <br />
              <span className="italic grad-text">{t("about.titleB")}</span> {t("about.titleC")}
              <br /> {t("about.titleD")}
            </h2>

            <div className="reveal-clip mt-10 relative overflow-hidden rounded-3xl aspect-[4/3]">
              <div className="absolute inset-0 iridescent opacity-85" />
              <div className="absolute inset-0 grain" />
              <div className="absolute inset-0 flex items-end p-6 md:p-8">
                <div className="text-[#0F0524]">
                  <div className="text-[10px] uppercase tracking-[0.3em] opacity-70 font-semibold">
                    {t("about.taglineTag")}
                  </div>
                  <div className="mt-2 font-display text-2xl md:text-3xl font-light leading-tight max-w-md">
                    {t("about.taglineHeroA")}
                    <br />
                    <span className="font-semibold">{t("about.taglineHeroB")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-10">
            <p className="reveal text-lg md:text-xl leading-relaxed text-[#0F0524] font-light">
              {t("about.leadA")}{" "}
              <span className="grad-text font-semibold">{t("about.leadB")}</span>{" "}
              {t("about.leadC")}{" "}
              <span className="grad-text font-semibold">{t("about.leadD")}</span>{" "}
              {t("about.leadE")}
            </p>
            <p className="reveal mt-5 text-[15px] leading-relaxed text-[#5C527A] max-w-xl">
              {t("about.sub")}
            </p>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {values.map((v, i) => (
                <div key={v.title} className="reveal glass rounded-2xl p-5" style={{ transitionDelay: `${i * 120}ms` }}>
                  <div className="flex items-start justify-between">
                    <h3 className="font-display text-xl font-medium text-[#0F0524]">{v.title}</h3>
                    <span className="h-1.5 w-1.5 rounded-full iridescent mt-2" />
                  </div>
                  <p className="mt-3 text-[13px] leading-relaxed text-[#5C527A]">{v.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
